// 各契約ページの同意状態
export type agreementStatus = {
  termsAgreement: agreeState;
  infoTradingAgreement: agreeState;
};

// 同意状態
export type agreeState = eAgreeState.notSelected | eAgreeState.agree | eAgreeState.notAgree;

export enum eAgreeState {
  notSelected,
  agree,
  notAgree
}

// 施設のタイプ（医療か介護か）
export type facilityType = '' | eFacilityState.medicalCare | eFacilityState.nursingCare;

export enum eFacilityState {
  medicalCare = '0',
  nursingCare = '1'
}
